import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HeroBanner from "../components/DigitalDairy/HeroBanner/HeroBanner"
import DigitalDiaryPosts from "../components/DigitalDairy/DigitalDiaryPosts/DigitalDiaryPosts"
import SponsorBlock from "../components/DigitalDairy/SponsorBlock/SponsorBlock"
import CheckUsContainer from "../components/DigitalDairy/CheckUsOut/CheckUsContainer"
import ExploreMission from "../components/GlobalComponents/ExploreMill/ExploreMission"
import Categories from "../components/DigitalDairy/Categories/Categories"

export default function DailyCategoryTemplate({ data }) {
  const categoryData = data.wpDailycategory
  const categoryName = categoryData.name
  const pagedataArticles = data?.allWpArticle
  const { title, metaDesc } = categoryData?.seo

  return (
    <Layout>
      <Seo title={title} description={metaDesc} />
      <HeroBanner data={pagedataArticles} />
      <Categories categoryName={categoryName} />
      <DigitalDiaryPosts
        data={{
          allWpArticle: pagedataArticles,
          wp: {
            aCFDigitalDiaryOptions: {
              aCFdigitalDiary:
                data?.wp?.aCFDigitalDiaryOptions?.aCFdigitalDiary,
            },
          },
        }}
      />

      <SponsorBlock />
      <CheckUsContainer showMileniumBlock={true} showTeamBlock={true} />
      <ExploreMission />
    </Layout>
  )
}

export const pagequery = graphql`
  query ($id: String!) {
    wpDailycategory(id: { eq: $id }) {
      seo {
        metaDesc
        title
      }
      name
      articles {
        nodes {
          id
        }
      }
    }
    allWpArticle(
      filter: { dailycategories: { nodes: { elemMatch: { id: { eq: $id } } } } }
    ) {
      nodes {
        author {
          node {
            id
            name
            aCFuser {
              uUserPhoto {
                node {
                  publicUrl
                  sourceUrl
                                     
                }
              }
            }
            avatar {
              url
            }
          }
        }
        content
        dailycategories {
          nodes {
            name
            uri
            slug
          }
        }
        dairytags {
          nodes {
            name
            uri
            slug
          }
        }
        date(formatString: "MMMM DD, Y")
        featuredImage {
          node {
            publicUrl
            sourceUrl
             
          }
        }
        title
        uri
        slug
      }
    }
    wp {
      aCFDigitalDiaryOptions {
        pageTitle
        aCFdigitalDiary {
          checkUsOutText
          checkUsOutVideo
          ddDigitalDairyText
          ddDigitalDairyTitle
          ddMeaningfulOpportunitiesTitle
          ddMeaningfulOpportunitiesText
          digitalDiaryImage {
            node {
              publicUrl
              sourceUrl
               
            }
          }
          digitalDiaryPost {
            node {
              publicUrl
              sourceUrl
               
            }
          }
          editorialTeam {
            description
            linkedinLink
            name
            position
            twitterLink
            photo {
              node {
                publicUrl
                sourceUrl
                                 
              }
            }
          }
          firstSidebarBanner {
            node {
              publicUrl
              sourceUrl
                             
            }
          }
          firstSidebarBannerLink
          meaningfulImage {
            node {
              publicUrl
              sourceUrl
                             
            }
          }
          secondSidebarBanner {
            node {
              publicUrl
              sourceUrl
                             
            }
          }
          secondSidebarBannerLink
          thirdSidebarBannerLink
          topDigitalDairyText
          thirdSidebarBanner {
            node {
              publicUrl
              sourceUrl
                             
            }
          }
        }
      }
    }
  }
`
